import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'

export class BaseLayerManager {
  constructor(map, baseLayers) {
    this.map = map;

    baseLayers.forEach(item => {
      const layer = new TileLayer({
        source: new XYZ({
          url: item.url
        }),
        visible:
          item.visible !== undefined
            ? item.visible
            : false,
        zIndex: 10
      });

      layer.set('name', item.name);

      this.map.addLayer(layer);
    });
  }

  // 切换底图
  switchLayer(name) {
    const layers = this.map
      .getLayers()
      .getArray();

    layers.forEach(layer => {
      if (layer instanceof TileLayer) {
        const key = layer.get('name');

        layer.setVisible(key === name);
      }
    });
  }
}